import React from 'react'
import { Props } from '../types'
import { motion } from 'framer-motion'
import FieldViewer from '../../../../../../../../components/field-viewer'

const UserAccount: React.FC<Props> = ({ user, fields, handleUpdate }) => {
  return (
    <motion.div
      className='flex h-full w-full flex-col'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {fields.map((field, index) => (
        <FieldViewer
          key={field.key}
          data={field}
          entity={user}
          handleUpdate={handleUpdate}
          isLast={fields.length - 1 === index}
        />
      ))}
    </motion.div>
  )
}

export default UserAccount
